export default "__VITE_PUBLIC_ASSET__7b4e7e6e__"